const state = {
	isFlatGroundHoriDrag: false,
	isFlatGroundVertiDrag: false,
	isFlatGroundUniformDrag: false,
};

const mutations = {
	setIsFlatGroundHoriDrag(state, isFlatGroundHoriDrag) {
		state.isFlatGroundHoriDrag = isFlatGroundHoriDrag;
	},
	setIsFlatGroundVertiDrag(state, isFlatGroundVertiDrag) {
		state.isFlatGroundVertiDrag = isFlatGroundVertiDrag;
	},
	setIsFlatGroundUniformDrag(state, isFlatGroundUniformDrag) {
		state.isFlatGroundUniformDrag = isFlatGroundUniformDrag;
	},
};

const actions = {
	setIsFlatGroundHoriDrag({ commit }, isFlatGroundHoriDrag) {
		commit("setIsFlatGroundHoriDrag", isFlatGroundHoriDrag);
	},
	setIsFlatGroundVertiDrag({ commit }, isFlatGroundVertiDrag) {
		commit("setIsFlatGroundVertiDrag", isFlatGroundVertiDrag);
	},
	setIsFlatGroundUniformDrag({ commit }, isFlatGroundUniformDrag) {
		commit("setIsFlatGroundUniformDrag", isFlatGroundUniformDrag);
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
};
